import { useContext } from "react";
import api from "@/utils/axios-util";
import axios from "axios";
import { parseISO, addMinutes } from "date-fns";
import { BookingContext } from "../contexts/HVBContext";
import { CalendarById } from "../@types/calendar";
import {
  APIResponse,
  CancellationPayload,
  ServicePayload,
} from "../utils/booking";

// ==========================================================================================

export const useBookingContext = () => useContext(BookingContext);

export const bookFreeConsult = async (params: ServicePayload) => {
  const payload = {
    ...params,
    utmCode: {
      utm_campaign: params.utm_campaign,
      utm_content: params.utm_content,
      utm_medium: params.utm_medium,
      utm_source: params.utm_source,
      utm_term: params.utm_term,
    },
  };
  const result = await api.post(`${process.env.TL_API}/staff/book`, payload);
  const { data, status } = result;
  return {
    data,
    status,
    isLoading: false,
    // isError:
    //   data?.zoho?.toLowerCase() !== "success!" ||
    //   !data?.calId ||
    //   status !== 201,
    isError:
      (data?.zoho && data?.zoho?.toLowerCase() === null) || status !== 201,
  };
};

const canCancelOrSched = (data: CalendarById) => {
  const {
    Cancelation_and_Rescheduling_Window_Min: cancelWindow,
    Start_DateTime,
  } = data ?? {
    Cancelation_and_Rescheduling_Window_Min: null,
    Start_DateTime: null,
  };
  if (!Start_DateTime) return true;

  let allowedDate: Date | null = Start_DateTime
    ? parseISO(Start_DateTime)
    : null;
  if (cancelWindow && Start_DateTime) {
    allowedDate = addMinutes(parseISO(Start_DateTime), -Number(cancelWindow));
  }
  if (!data?.Cancelation_and_Rescheduling_Window_Min) return true;
  else if (allowedDate) return new Date() < allowedDate;
  else return true;
};

export const getFreeConsult = async (
  id: string,
): Promise<APIResponse<CalendarById>> => {
  const result = await api.get(`${process.env.TL_API}/calendar/${id}`);

  const { data, status } = result;

  return {
    data: {
      ...data,
      canCancelOrResched: canCancelOrSched(data),
    } as CalendarById,
    isLoading: false,
    status,
    isError: status !== 200,
  };
};

export const updateFreeConsult = async (params: ServicePayload) => {
  const payload = {
    ...params,
    utmCode: {
      utm_campaign: params.utm_campaign,
      utm_content: params.utm_content,
      utm_medium: params.utm_medium,
      utm_source: params.utm_source,
      utm_term: params.utm_term,
    },
  };
  const result = await api.put(`${process.env.TL_API}/staff/book`, payload);
  const { data, status } = result;
  return {
    data,
    status,
    isLoading: false,
    isError: data === null || status !== 200,
  };
};

export const cancelFreeConsult = async (params: CancellationPayload) => {
  const result = await api.put(`${process.env.TL_API}/staff/cancel`, params);
  const { data, status } = result;
  return {
    ...(data || {}),
    status,
    isLoading: false,
    isError: status !== 200 || data === "",
  };
};

export const checkMeeting = async (email: string) => {
  const result = await axios.get(`/api/check-booking/?email=${email}`);
  const { data, status } = result;
  return {
    ...(data || {}),
    status,
    isLoading: false,
    isError: status !== 200,
  };
};

export const cancelBooking = async (bookingId: string) => {
  const result = await axios.post(`/api/cancel-booking`, {
    booking_id: bookingId,
  });
  const { data, status } = result;
  return {
    ...(data || {}),
    status,
    isLoading: false,
    isError: status !== 200,
  };
};
